// extracted by mini-css-extract-plugin
module.exports = {"dumb_1":"RandomArticles_dumb_1___iqFC","dumb_2":"RandomArticles_dumb_2__kn6To","header":"RandomArticles_header__ZSXzW"};